export default __webpack_public_path__ + "static/media/attach-docs.90d9edd0.svg";